// src/utils/utils.js

export const updateStatusText = (value, trackId) => {
    const statusText = {
      "1": "15 Min",
      "2": "30 Min",
      "3": "60 Min",
      "4": "2 Std",
      "5": "3 Std",
      "6": "Im Einsatz",
      "7": "Abgemeldet N/A",
      "8": "Im Betrieb"
    };
  
    document.getElementById("hali_status_" + trackId).innerHTML = statusText[value] || "";
  };
  
  export const filterHelicopters = (geojson, filterOption) => {
    const filterConditions = {
      "15 Min": (status) => status === "1",
      "30 Min": (status) => status <= "2",
      "60 Min": (status) => status <= "3",
      "2 Std": (status) => status <= "4",
      "3 Std": (status) => status <= "5",
      "Im Einsatz": (status) => status === "6",
      "Abgemeldet N/A": (status) => status === "7",
      "Im Betrieb": (status) => status === "8"
    };
  
    if (filterOption === "Show all") {
      return geojson;
    }
  
    if (filterOption === "Hide all") {
      return {};
    }
  
    const condition = filterConditions[filterOption];
    if (!condition) {
      return {};
    }
  
    return Object.keys(geojson).reduce((filtered, key) => {
      const helicopter = geojson[key];
      if (condition(helicopter.Einsatzbereit_in)) {
        filtered[key] = helicopter;
      }
      return filtered;
    }, {});
  };
  
  export const addFlightPathToMap = (map, heliCoords, fireCoords) => {
    map.addSource('flightPath', {
      'type': 'geojson',
      'data': {
        'type': 'Feature',
        'properties': {},
        'geometry': {
          'type': 'LineString',
          'coordinates': [
            [heliCoords[0], heliCoords[1]],
            [fireCoords.lng, fireCoords.lat]
          ]
        }
      }
    });
  
    map.addLayer({
      'id': 'flightPathLayer',
      'type': 'line',
      'source': 'flightPath',
      'layout': {
        'line-join': 'round',
        'line-cap': 'round'
      },
      'paint': {
        'line-color': '#1c3351',
        'line-width': 2
      }
    });
  };
  
  export const displayDistanceAndTimeInfo = (distance, data, map, t) => {
    const distanceKm = distance / 1000;
    const flightTimeHours = distanceKm / 200; // 200 km/h speed
    const flightTimeMinutes = Math.round(flightTimeHours * 60);
    const flightTimeHoursRounded = Math.floor(flightTimeMinutes / 60);
    const flightTimeMinutesRemainder = flightTimeMinutes % 60;
  
    let availabilityMinutes = 0;
    let availabilityStatus = "";
    switch (data.Einsatzbereit_in) {
      case "1": availabilityMinutes = 15; availabilityStatus = "15 Min"; break;
      case "2": availabilityMinutes = 30; availabilityStatus = "30 Min"; break;
      case "3": availabilityMinutes = 60; availabilityStatus = "60 Min"; break;
      case "4": availabilityMinutes = 120; availabilityStatus = "2 Std"; break;
      case "5": availabilityMinutes = 180; availabilityStatus = "3 Std"; break;
      case "6": availabilityStatus = "Im Einsatz"; break;
      case "7": availabilityStatus = "Abgemeldet N/A"; break;
      case "8": availabilityStatus = "Im Betrieb"; break;
      default: availabilityStatus = "Unknown";
    }
  
    let alertText = `Distance to fire: ${distanceKm.toFixed(2)} km\n\n` +
                    `Flight time: ${flightTimeHoursRounded} hours and ${flightTimeMinutesRemainder} minutes\n\n`
  
    if (["6", "7", "8"].includes(data.Einsatzbereit_in)) {
      alertText += `Availability time: Unknown\n\n` +
                   `Total estimated time: Unknown`;
    } else {
      const totalMinutes = flightTimeMinutes + availabilityMinutes;
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      alertText += `Availability time: ${availabilityMinutes} minutes\n\n` +
                   `Total estimated time: ${hours} hours and ${minutes} minutes`;
    }
  
    swal({
      title: "Distance and Time",
      text: alertText,
      icon: "info",
    }).then(() => {
      if (map.getSource('flightPath')) {
        map.removeLayer('flightPathLayer');
        map.removeSource('flightPath');
      }
    });
  };